export default {
    en: {
        hint: "Click or drag the file here to upload",
        loading: "Uploading…",
        noSupported: "Browser is not supported, please use IE10+ or an other browser",
        success: "Upload was successful",
        fail: "Upload failed, please try again",
        preview: "Preview",
        btn: {
            off: "Cancel",
            close: "Close",
            back: "Back",
            save: "Save",
        },
        error: {
            onlyImg: "Image only",
            outOfSize: "Image exceeds size limit: ",
            lowestPx: "Image's size is too low. Expected at least: ",
        },
    },
};
